<div
  class="certificate-groups-list"
  *ngIf="customer$ | async">
  <mat-card class="mat-elevation-z2">
    <mat-card-title> </mat-card-title>
    <mat-card-content>
      <div
        class="row"
        *ngFor="
          let certificateGroup of certificateGroups$ | async;
          trackBy: trackById
        ">
        <div class="col">
          <div class="certificate-group-row">
            <div class="certificate-group-details">
              <mat-form-field>
                <mat-label>{{
                  ("title" | i18n) || "Titel" | titlecase
                }}</mat-label>
                <input
                  matInput
                  required
                  [(ngModel)]="certificateGroup.displayName"
                  [name]="'displayName-' + certificateGroup.id" />
              </mat-form-field>
            </div>
            <div class="certificate-group-certificates">
              <app-certificate-select
                [selectedMappedCertificates]="
                  certificateGroup.certificates || []
                "
                [noCertificateGroups]="true"
                (selectionChanged)="
                  certificatesSelected(certificateGroup, $event)
                "></app-certificate-select>
            </div>
            <div class="certificate-group-buttons">
              <button
                class="certificate-group-button"
                mat-button
                type="button"
                (click)="cancelChanges(certificateGroup.id)"
                [matTooltip]="('cancel' | i18n) || 'Abbrechen' | titlecase">
                <mat-icon
                  class="certificate-group-button-icon"
                  svgIcon="close"></mat-icon>
              </button>
              <button
                class="certificate-group-button save-button"
                mat-button
                type="button"
                (click)="saveCertificateGroup(certificateGroup.id)"
                [matTooltip]="('save' | i18n) || 'Speichern' | titlecase">
                <mat-icon
                  class="certificate-group-button-icon"
                  svgIcon="save"></mat-icon>
              </button>
              <button
                class="certificate-group-button delete-button"
                mat-button
                type="button"
                (click)="deleteCertificateGroup(certificateGroup.id)"
                [matTooltip]="('remove' | i18n) || 'Löschen' | titlecase">
                <mat-icon
                  class="certificate-group-button-icon"
                  svgIcon="delete-trash-remove"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row"
        *ngFor="
          let certificateGroup of certificateGroupsInCreation$ | async;
          let i = index
        ">
        <div class="col">
          <div class="certificate-group-row">
            <div class="certificate-group-details">
              <mat-form-field>
                <mat-label>{{
                  ("title" | i18n) || "Titel" | titlecase
                }}</mat-label>
                <input
                  matInput
                  required
                  [(ngModel)]="certificateGroup.displayName"
                  [name]="'newDisplayName-' + i" />
              </mat-form-field>
            </div>
            <div class="certificate-group-certificates">
              <app-certificate-select
                [selectedMappedCertificates]="
                  certificateGroup.certificates || []
                "
                [noCertificateGroups]="true"
                (selectionChanged)="
                  certificatesSelected(certificateGroup, $event)
                "></app-certificate-select>
            </div>
            <div class="certificate-group-buttons">
              <button
                class="certificate-group-button"
                mat-button
                type="button"
                (click)="cancelNewCertificateGroup(i)"
                [matTooltip]="('cancel' | i18n) || 'Abbrechen' | titlecase">
                <mat-icon
                  class="certificate-group-button-icon"
                  svgIcon="close"></mat-icon>
              </button>
              <button
                class="certificate-group-button save-button"
                mat-button
                type="button"
                (click)="saveNewCertificateGroup(i)"
                [matTooltip]="('save' | i18n) || 'Speichern' | titlecase">
                <mat-icon
                  class="certificate-group-button-icon"
                  svgIcon="save"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <button
            class="outline-pill-button icon-left"
            type="button"
            data-cy="add-certificate-group-button"
            (click)="addNewCertificateGroup()">
            <mat-icon
              class="custom-text-icon-button-icon"
              svgIcon="add-circle-plus"></mat-icon>
            {{
              ("addCertificateGroup" | i18n) ||
                "Qualifikationsgruppe hinzufügen" | titlecase
            }}
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
